/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
const React = require("react")
const Layout = require("./src/components/layout/layout").default

exports.wrapPageElement = ({ element, props }) => {
  const { pageContext } = props
  if (typeof window !== "undefined") {
    window.___gatsbyIntl = pageContext
  }
  return <Layout {...props}>{element}</Layout>
}

const { anchorate } = require("anchorate")

// Determine whether a navigation should preserve scroll position.
// Same-page filter updates (e.g. Algolia) keep the user where they are.
const isFilterUpdate = (location, prevLocation) => {
  const prevPathname = prevLocation?.pathname ?? null
  const prevTab = new URLSearchParams(prevLocation?.search ?? "").get("tab")
  const currentTab = new URLSearchParams(location.search ?? "").get("tab")
  const isTabSwitch = prevTab !== currentTab
  return !!location.search && prevPathname === location.pathname && !isTabSwitch
}

const forceScrollTop = () => {
  document.documentElement.style.scrollBehavior = "auto"
  window.scrollTo(0, 0)
  // Catch layout shifts that happen after the first paint (image loads,
  // async data fetches, body class changes from header/nav components).
  requestAnimationFrame(() => {
    window.scrollTo(0, 0)
    requestAnimationFrame(() => window.scrollTo(0, 0))
  })
}

exports.shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) => {
  if (isFilterUpdate(location, prevRouterProps?.location)) return false
  if (!location.hash) forceScrollTop()
  return false
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (!isFilterUpdate(location, prevLocation) && !location.hash) {
    forceScrollTop()
  }
  anchorate()
}

exports.onClientEntry = () => {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    try {
      window.history.scrollRestoration = "manual";
    } catch (e) {
      // Some browsers might throw in strict contexts — ignore safely.
    }
  }
};